import styled from 'styled-components';

export const SReactSpinePlayer = styled.div`
  position: absolute;
  background-size: contain;
  width: 600px;
  height: 185px;
  bottom: 0;
  z-index: 2;
  pointer-events: none;

  @media (max-width: 854px) and (max-aspect-ratio: 1/1) {
    width: 580px;
    height: 180px;
  }

  @media (max-width: 600px) and (max-aspect-ratio: 1/1) {
    width: 540px;
    height: 166px;
  }

  @media (max-width: 560px) and (max-aspect-ratio: 1/1) {
    width: 480px;
    height: 146px;
  }

  @media (max-width: 500px) and (max-aspect-ratio: 1/1) {
    width: 440px;
    height: 137px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    width: 400px;
    height: 123px;
  }

  @media (max-width: 410px) and (max-aspect-ratio: 1/1) {
    width: 360px;
    height: 112px;
  }

  @media (max-width: 360px) and (max-aspect-ratio: 1/1) {
    width: 300px;
    height: 94px;
  }
`;
